import { EmotionIcon } from '@hotjar/webapp/features/Feedback/EmotionIcon';
import type { EmotionStyle } from '@hotjar/webapp/features/Feedback/domain/EmotionStyle';
import type { ListOption } from '@hotjar/global-filters';

export enum RATING_TYPE {
  HATE = '0',
  DISLIKE = '1',
  NEUTRAL = '2',
  LIKE = '3',
  LOVE = '4',
}

export const RATING_TO_RATING_TYPE_ENUM: Record<string, RATING_TYPE> = {
  '0': RATING_TYPE.HATE,
  '1': RATING_TYPE.DISLIKE,
  '2': RATING_TYPE.NEUTRAL,
  '3': RATING_TYPE.LIKE,
  '4': RATING_TYPE.LOVE,
};

export function ratingFilterOptions(emotionStyle: EmotionStyle): ListOption<RATING_TYPE>[] {
  return [
    {
      value: RATING_TYPE.LOVE,
      label: 'Love',
      content: <EmotionIcon emotionStyle={emotionStyle} score={4} size="s" />,
    },
    {
      value: RATING_TYPE.LIKE,
      label: 'Like',
      content: <EmotionIcon emotionStyle={emotionStyle} score={3} size="s" />,
    },
    {
      value: RATING_TYPE.NEUTRAL,
      label: 'Neutral',
      content: <EmotionIcon emotionStyle={emotionStyle} score={2} size="s" />,
    },
    {
      value: RATING_TYPE.DISLIKE,
      label: 'Dislike',
      content: <EmotionIcon emotionStyle={emotionStyle} score={1} size="s" />,
    },
    {
      value: RATING_TYPE.HATE,
      label: 'Hate',
      content: <EmotionIcon emotionStyle={emotionStyle} score={0} size="s" />,
    },
  ];
}

export type RatingFilterValue = RATING_TYPE[] | undefined;

export function areAllRatingsIncluded(ratings: RATING_TYPE[]): boolean {
  return (
    ratings.includes(RATING_TYPE.HATE) &&
    ratings.includes(RATING_TYPE.DISLIKE) &&
    ratings.includes(RATING_TYPE.NEUTRAL) &&
    ratings.includes(RATING_TYPE.LIKE) &&
    ratings.includes(RATING_TYPE.LOVE)
  );
}
